const KEY = "signage-theme";

export function getTheme() {
  try {
    return localStorage.getItem(KEY) || "dark";
  } catch {
    return "dark";
  }
}

export function applyTheme(t) {
  document.documentElement.classList.toggle("light", t === "light");
}

export function setTheme(t) {
  try {
    localStorage.setItem(KEY, t);
  } catch {
    // ignorieren
  }
  applyTheme(t);
  window.dispatchEvent(new Event("themechange"));
}
